"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateSchemasRequest = exports.PartialSchema = exports.Schema = exports.RelationshipMapConverter = exports.Relationship = void 0;
var createStringMapSerializers_1 = __importDefault(require("../common/createStringMapSerializers"));
var json2typescript_1 = require("json2typescript");
var Relationship = (function () {
    function Relationship(partial) {
        this.ref = '';
        this.foreignKey = '';
        this.isList = false;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('ref'),
        __metadata("design:type", Object)
    ], Relationship.prototype, "ref", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('foreign_key'),
        __metadata("design:type", Object)
    ], Relationship.prototype, "foreignKey", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('is_list'),
        __metadata("design:type", Object)
    ], Relationship.prototype, "isList", void 0);
    Relationship = __decorate([
        (0, json2typescript_1.JsonObject)('Relationship'),
        __metadata("design:paramtypes", [Object])
    ], Relationship);
    return Relationship;
}());
exports.Relationship = Relationship;
var relationshipMapSerializers = (0, createStringMapSerializers_1.default)(Relationship);
var RelationshipMapConverter = (function () {
    function RelationshipMapConverter() {
        this.serialize = relationshipMapSerializers.serialize;
        this.deserialize = relationshipMapSerializers.deserialize;
    }
    RelationshipMapConverter = __decorate([
        json2typescript_1.JsonConverter
    ], RelationshipMapConverter);
    return RelationshipMapConverter;
}());
exports.RelationshipMapConverter = RelationshipMapConverter;
var Schema = (function () {
    function Schema(partial) {
        this.id = '';
        this.schema = {};
        this.metadata = {};
        this.relationships = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], Schema.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('schema', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], Schema.prototype, "schema", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('metadata', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], Schema.prototype, "metadata", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('relationships', RelationshipMapConverter, true),
        __metadata("design:type", Object)
    ], Schema.prototype, "relationships", void 0);
    Schema = __decorate([
        (0, json2typescript_1.JsonObject)('Schema'),
        __metadata("design:paramtypes", [Object])
    ], Schema);
    return Schema;
}());
exports.Schema = Schema;
var PartialSchema = (function () {
    function PartialSchema(partial) {
        this.id = '';
        this.metadata = {};
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], PartialSchema.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('metadata', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], PartialSchema.prototype, "metadata", void 0);
    PartialSchema = __decorate([
        (0, json2typescript_1.JsonObject)('PartialSchema'),
        __metadata("design:paramtypes", [Object])
    ], PartialSchema);
    return PartialSchema;
}());
exports.PartialSchema = PartialSchema;
var GenerateSchemasRequest = (function () {
    function GenerateSchemasRequest(partial) {
        this.dataSourceId = '';
        this.allSchemas = false;
        this.allUnconfiguredSchemas = false;
        this.limit = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('data_source_id', String),
        __metadata("design:type", Object)
    ], GenerateSchemasRequest.prototype, "dataSourceId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('all_schemas', Boolean),
        __metadata("design:type", Object)
    ], GenerateSchemasRequest.prototype, "allSchemas", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('all_unconfigured_schemas', Boolean),
        __metadata("design:type", Object)
    ], GenerateSchemasRequest.prototype, "allUnconfiguredSchemas", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('limit', Number, true),
        __metadata("design:type", Number)
    ], GenerateSchemasRequest.prototype, "limit", void 0);
    GenerateSchemasRequest = __decorate([
        (0, json2typescript_1.JsonObject)('GenerateSchemasRequest'),
        __metadata("design:paramtypes", [Object])
    ], GenerateSchemasRequest);
    return GenerateSchemasRequest;
}());
exports.GenerateSchemasRequest = GenerateSchemasRequest;
//# sourceMappingURL=Schema.js.map